/* @flow weak */
import _ from 'lodash';

const STRIPE_JS = 'https://js.stripe.com/v2/';

let loadId = null;

export default class StripeAPI {
  static load() {
    if (window.Stripe) {
      return Promise.resolve(window.Stripe);
    }

    const $script = require('scriptjs');

    if (!loadId) {
      $script(STRIPE_JS, (loadId = _.uniqueId('stripe')));
    }

    return new Promise(resolve => {
      $script.ready(loadId, () => {
        resolve(window.Stripe);
      });
    });
  }

  static setPublishableKey(publishableKey) {
    return StripeAPI.load().then(stripe => {
      stripe.setPublishableKey(publishableKey);
      return Promise.resolve();
    });
  }

  static createCardToken(card, callback) {
    StripeAPI.load().then(stripe => {
      stripe.card.createToken(card, callback);
    }).catch(e => console.error('StripeAPI createCardToken failed', e));
  }

  static createPIIToken(pii, callback) {
    StripeAPI.load().then(stripe => {
      stripe.piiData.createToken(pii, callback);
    }).catch(e => console.error('StripeAPI createPIIToken failed', e));
  }

  static createBankAccountToken(account, callback) {
    StripeAPI.load().then(stripe => {
      stripe.bankAccount.createToken(account, callback);
    }).catch(e => console.error('StripeAPI createBankAccountToken failed', e));
  }
}



// WEBPACK FOOTER //
// ./src/lib/StripeAPI.js